module.exports = __webpack_public_path__ + "img/frame (45).672acb65.jpg";